import { Box } from '@material-ui/core';
import { postSendQrCardExpedition } from '@nemuru-eng/js-api-client';
import { useState } from 'react';

import { useWidth } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/_shared/hooks/useWidth';
import { CardOnboardingPaymentMethodDetailEntity } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/CardOnboarding/_shared/entities/PaymentMethodDetail/CardOnboardingPaymentMethodDetailEntity';
import { CustomPaper } from '@/components/shared/components/CustomPaper';
import { FlexColumn } from '@/components/shared/components/FlexColumn';
import { Font } from '@/components/shared/components/Font';
import { StandardButton } from '@/components/shared/components/StandardButton';
import { Text } from '@/components/shared/components/Text';
import { useRequest } from '@/hooks/requests/useRequest';

interface NextActionPrintCardProps {
  paymentMethodDetailEntity: CardOnboardingPaymentMethodDetailEntity;
}

export const NextActionPrintCard = ({ paymentMethodDetailEntity }: NextActionPrintCardProps) => {
  const { width, ref } = useWidth<HTMLDivElement>();
  const { request, loading } = useRequest();

  const [hasSent, setHasSent] = useState(false);

  const loanId = paymentMethodDetailEntity.paymentMethodId;
  const isValidationDone = paymentMethodDetailEntity.areCardDocumentsValidated();

  if (!loanId) {
    return null;
  }

  const sendPrintQr = async () => {
    try {
      await request(postSendQrCardExpedition, { loanId });
      setHasSent(true);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <CustomPaper fill="grey.light">
      <div ref={ref}>
        <Box display="flex" flexDirection={width && width > 600 ? 'row' : 'column'} width="100%" gridGap={24}>
          <FlexColumn gridGap={4} flexGrow={1} minWidth={300}>
            <Font variant="body2" color="title" display="block">
              <Text tId="PRINT_CARD_DESCRIPTION" />
            </Font>
            {hasSent ? (
              <Font variant="body2" color="title" display="block">
                <Text tId="PRINT_CARD_SENT_SUCCESS" />
              </Font>
            ) : null}
            <Font variant="caption" color="textSecondary" display="block">
              <Text tId="PRINT_CARD_QR_STUB" />
            </Font>
          </FlexColumn>
          <Box flexShrink={0} display="flex" alignItems="center">
            <StandardButton
              main
              size="small"
              loading={loading}
              disabled={loading || !isValidationDone}
              onClick={sendPrintQr}
            >
              <Text tId="PRINT_CARD_CTA" />
            </StandardButton>
          </Box>
        </Box>
      </div>
    </CustomPaper>
  );
};
